namespace Solovis.Reports.Util {

  export class OwnershipChainNavigator {

    private investmentIdToOwnerIdMap: { [key: number]: number };
    private ownerIdToEntityMap: { [key: number]: any };

    constructor(modelEnvironment: any) {
      var entities = modelEnvironment.entities || modelEnvironment.entityList;
      var investments = modelEnvironment.investments || modelEnvironment.investmentList;

      const investmentIdToOwnerIdMap = {};
      const ownerIdToEntityMap = {};

      if (investments) {
        investments.forEach(function (investment) {
          investmentIdToOwnerIdMap[investment.id] = investment.ownerId;
        });
      }

      if (entities) {
        entities.forEach(function (entity) {
          ownerIdToEntityMap[entity.id] = entity;
        });
      }

      this.investmentIdToOwnerIdMap = investmentIdToOwnerIdMap;
      this.ownerIdToEntityMap = ownerIdToEntityMap;
    }

    public static findAbsoluteOwner(ownershipChain: { investmentId: any, nextLevel: any }, modelEnv: InvData.ModelEnvironment): any {
      let chainHasDepth = true;
      let innerLink = ownershipChain;

      while (chainHasDepth) {
        if (innerLink?.nextLevel) {
          innerLink = innerLink.nextLevel;
        } else {
          chainHasDepth = false;
        }
      }

      const investment = modelEnv.getInvestmentById(innerLink?.investmentId);
      return modelEnv.getEntityById(investment?.ownerId);
    }

    public ownerAtLevel(ownershipChain: any, level: string | number) : string {
      var ownerAtLevel = this.findOwners(ownershipChain)[level];

      if (ownerAtLevel) {
        return ownerAtLevel;
      } else {
        return "";
      }
    }

    public findOwners(ownershipChain: any) : string[] {
      if (!ownershipChain) {
        return []
      }

      var chainHasDepth = true;
      var innerLink = ownershipChain;
      var owners = [];

      while (chainHasDepth) {
        var investmentId = innerLink.investmentId;
        var foundOwner = this.findOwnerByInvestmentId(investmentId);
        if (foundOwner) {
          owners.push(foundOwner.label);
        }
        if (innerLink.nextLevel) {
          innerLink = innerLink.nextLevel;
        } else {
          chainHasDepth = false;
        }
      }

      return owners.reverse();
    }

    private findOwnerByInvestmentId(investmentId: number) {
      var ownerId = this.investmentIdToOwnerIdMap[investmentId];
      return this.ownerIdToEntityMap[ownerId];
    }
  }
}